import { type Node, type NodeProps, Position } from '@xyflow/react';
import React from 'react';

import { createHandleId } from '../../utils/handle-ids';
import { BaseNode, type NodeData } from './BaseNode';
import { NodeHandle } from './NodeHandle';

export type ZipNodeType = Node<NodeData, 'custom_zip'>;

export const ZipNode: React.FC<NodeProps<ZipNodeType>> = ({
  id,
  data,
  selected,
}) => {
  const config = data.config as Record<string, unknown>;
  const combineStrategy = (config.combine_strategy as string) || 'merge';
  const subtitle = `Zip (${combineStrategy})`;

  // Extract connection state from node data for visual indicators
  const activeConnection = data.activeConnection;
  const isValidTargetHandle = data.isValidTargetHandle as
    | ((targetHandle: string) => boolean)
    | undefined;
  const isActiveConnection = !!activeConnection;

  return (
    <BaseNode
      nodeId={id}
      data={data}
      category="flow"
      subtitle={subtitle}
      selected={selected}
    >
      {/* Fixed 2 input handles for left and right arrays */}
      <NodeHandle
        type="target"
        position={Position.Left}
        id="left_array"
        blockId={id}
        style={{ top: '35%' }}
        isActiveConnection={isActiveConnection}
        isValidTarget={
          isValidTargetHandle
            ? isValidTargetHandle(createHandleId(id, 'left_array'))
            : undefined
        }
      />
      <NodeHandle
        type="target"
        position={Position.Left}
        id="right_array"
        blockId={id}
        style={{ top: '65%' }}
        isActiveConnection={isActiveConnection}
        isValidTarget={
          isValidTargetHandle
            ? isValidTargetHandle(createHandleId(id, 'right_array'))
            : undefined
        }
      />
      {/* Single output handle */}
      <NodeHandle
        type="source"
        position={Position.Right}
        id="result"
        blockId={id}
        isActiveConnection={isActiveConnection}
      />
    </BaseNode>
  );
};
